import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';

class SaveUsageSettings {
	constructor(
		public readonly scope: AssignmentScope,
		// Bare enum value (`interview_transcription`, …): it travels in the URL, never in the body.
		public readonly usage: string,
		public readonly body: Record<string, unknown>,
	) {
		Object.freeze(this);
	}

	// `usage` is already in the URL: repeating it here would fail `forbidNonWhitelisted`. `body` is
	// rendered as-is — composing it (which keys, `null` vs. an explicit empty value) is the FormData's job.
	toJSON(): Record<string, unknown> {
		return this.body;
	}
}

export default SaveUsageSettings;
